// components/routes/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children, role }) {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role");

  // If no token, redirect to login
  if (!token) return <Navigate to="/" replace />;

  // If role is specified, check role
  if (role && userRole !== role) return <Navigate to="/" replace />;

  return children;
}